import { AccountMinusIcon } from './AccountMinusIcon';

/**
 * author: REJack
 * id 9CF96408-1A24-4040-AD04-011183CC9ABC
 * name account-minus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-minus.svg
 * tags
 * - Account / User 
 */
export const UserMinusIcon = AccountMinusIcon;
export default UserMinusIcon